import { Copyright } from "../components";

function Disclaimer() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          <code>Disclaimer</code><br/>
          Błędy się zdarzają</p>
          <p>
          TOT - Time Over Target<br/>
          ETA - Estimated Time of Arrive<br/>
          ETE - Estimated Time Elapsed<br/>
        </p>
        <p style={{ padding: 24 }}>
        <small>
        <small>

          THE SOFTWARE AND ACCOMPANYING DOCUMENTATION, IF ANY,  IS PROVIDED "AS IS". AUTHOR HAS NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT, UPDATES, ENHANCEMENTS, OR MODIFICATIONS.
          </small>
          </small>
        </p>
      </header>
      <Copyright />
    </div>
  );
}

export default Disclaimer;